<template>
  <div>
    <v-app v-if="applidationLoaded" id="app">
      <Header v-model="drawer" :collapsed="collapsed" />
      <Sidebar v-model="drawer" />
      <v-main>
        <v-container class="page-container" fluid fill-height>
          <router-view />
        </v-container>
      </v-main>
      <Footer />
      <Alert />
      <AuthModal />
      <InfoPopup v-model="popup" />
    </v-app>
    <div v-else>
      <Spinner />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "DefaultLayout",
  components: { Header, Footer },

  data() {
    return {
      drawer: false,
      popup: null,
      collapsed: window.pageYOffset > 50,
    };
  },
  created() {
    this.initApplication();

    document.body.onscroll = () => {
      this.collapsed = window.pageYOffset > 50;
    };

    this.$cable.subscribe({
      channel: "NotificationChannel",
    });

    window.addEventListener("beforeunload", () => {
      this.$gtag.event("PageUnload", {});
    });
  },
  channels: {
    NotificationChannel: {
      connected() {
        console.log("Connected Notifications");
      },
      rejected() {
        console.log("Rejected Notifications");
      },
      received({ type, payload }) {
        switch (type) {
          case "base":
            this.$alert(
              `<b>${payload.title}</b><br>${payload.description}`,
              "info",
              { timeout: -1 }
            );
            break;
          case "popup":
            this.popup = payload;
            break;
          case "logout":
            if (payload.user_id == this.currentUser?.id)
              this.$store.dispatch("auth/logout");
            break;
        }
      },
    },
  },
  methods: {
    async initApplication() {
      await this.$store.dispatch("application/init");
      this.initPage();
    },
    initPage() {
      const pageSlug = this.$route.query.page;
      if (pageSlug) {
        const page = this.$store.getters["page/list"].find(
          (s) => s.slug == pageSlug
        );
        if (page) this.$store.commit("page/setActive", page);
      }
    },
  },
  computed: {
    routerKey() {
      return this.activePage?.id || 0;
    },
  },
};
</script>

<style scoped lang="scss">
#app {
  margin: auto;
  position: relative;
  overflow: hidden;

  .v-main {
    overflow: hidden;
  }
}
.page-container {
  display: block !important;
  padding: 0;
  overflow: hidden;
}

@media screen and (max-width: 960px) {
  #app .v-main {
    padding-bottom: 0 !important;
  }
}
</style>
